<script>
    import { Swiper, SwiperSlide } from "swiper/svelte";
    import "./landingPage.css";
    import "swiper/css/pagination";
    import "swiper/css/navigation";
    import "swiper/css";
    import {sliderHomepage, sliderProject} from "../../constants/constants";
    import BannerSlider from "./banner-slider/BannerSlider.svelte";
    import ProjectSlider from "./project-slider/ProjectSlider.svelte";
    import UnixTiers from "./unix-tiers/UnixTiers.svelte";
    import DiveDeeper from "./dive-deeper/DiveDeeper.svelte";
</script>

<div>
    <Swiper
            slidesPerView={sliderHomepage.slidesPerView}
            spaceBetween={sliderHomepage.spaceBetween}
            slidesPerGroup={sliderHomepage.slidesPerGroup}
            loop={sliderHomepage.loop}
            pagination={sliderHomepage.pagination}
            modules={sliderHomepage.modules}
            class="myBannerSwiper">
            <SwiperSlide>
                <BannerSlider />
            </SwiperSlide>
            <SwiperSlide>
                <BannerSlider />
            </SwiperSlide>
            <SwiperSlide>
                <BannerSlider />
            </SwiperSlide>
    </Swiper>
    <Swiper
            slidesPerView={sliderProject.slidesPerView}
            spaceBetween={sliderProject.spaceBetween}
            slidesPerGroup={sliderProject.slidesPerGroup}
            loop={sliderProject.loop}
            navigation={sliderProject.navigation}
            modules={sliderProject.modules}
            breakpoints={sliderProject.breakPoint}
            class="myProjectSwiper">
        <SwiperSlide>
            <ProjectSlider />
        </SwiperSlide>
        <SwiperSlide>
            <ProjectSlider />
        </SwiperSlide>
        <SwiperSlide>
            <ProjectSlider />
        </SwiperSlide>
        <SwiperSlide>
            <ProjectSlider />
        </SwiperSlide>
        <SwiperSlide>
            <ProjectSlider />
        </SwiperSlide>
    </Swiper>
    <UnixTiers/>
    <DiveDeeper/>
</div>